import React, { useEffect, useState } from "react";
import { fetchRolesAndAccess } from "../../../containers/actions/common/rolesAndAccessActions";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { fetchDepartmentDetails } from "../../../../../containers/actions/userActions";
import { fetchUserfromDepartment } from "../../../../../containers/actions/userActions";
import InviteTeamMember from "./inviteTeamMember";
import ViewTeamMembersColumn from "./ViewTeamMembersColumn";
import EditTeamMembersColumn from "./EditTeamMembersColumn";
import ViewDetails from "../teamMembers/viewDetails";
//import rolesAndAccessActions from "../../../containers/actions/common/rolesAndAccessActions";

import {
  Box,
  Button,
  Drawer,
  Grid,
  makeStyles,
  MenuItem,
  Select,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  FormControl,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AddIcon from "@material-ui/icons/Add";
import { ChevronLeft, ChevronRight, Refresh } from "@material-ui/icons";
import moment from "moment";
import CreateNewRole from "./createNewRole";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import PaginationInput from "../models/pagination/PaginationInput";
import ViewRolesAndAccess from "./ViewRolesAndAccess";
import EditRolesAndAccess from "./EditRolesAndAccess";
import {
  FETCH_ROLES_AND_ACCESS_LOADING,
  UPDATE_COLLABORATOR_ROLE_CHANGES,
} from "../../../containers/actions/types";
import { getScreensAccess } from "../../../containers/actions/common/accessControl";
import { getFeaturesAccess } from "../../../containers/actions/common/accessControl";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#0d6efd",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#0d6efd",
    },
  },
  dialogContent: {
    textAlign: "center",
    padding: "24px 36px 24px 36px",
  },
  avatar: {
    color: "green",
    margin: "0 auto",
    fontSize: "54px",
  },
  dialogActions: {
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  blueButton: {
    backgroundImage: "linear-gradient(to right, #301232, #1A2D6C, #173072)",
    color: "white",
    border: "1px solid black",
    textTransform: "none",
    borderRadius: "2rem",
    paddingLeft: "16px",
    paddingRight: "16px",
    "&:hover": {
      backgroundColor: "green",
      background: "green",
      color: "white",
      border: "1px solid green",
    },
  },
  boldText: {
    fontWeight: "bold",
  },
  drawerPaper: {
    width: "30vw", // Set the drawer width here
  },
  actionButtonStyle: {
    backgroundColor: "#c8ddfb",
    borderRadius: "4px",
    textTransform: "none",
    padding: "6px 12px",
    color: "black",
    "&:hover": {
      backgroundColor: "#6495ED",
    },
  },
  iconButtonStyle: {
    color: "black",
    border: "1px solid black",
    borderRadius: "5px",
    padding: "4px",
  },
  drawerPaper: {
    width: "30vw",
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "20px",
  },
  paginationButton: {
    margin: "0 5px",
    fontSize: "16px",
  },
  selectDropdown: {
    border: "none",
    padding: "0",
    minWidth: "50px",
    fontSize: "14px",
  },
  tableRow: {
    height: "40px",
  },
  tableCell: {
    padding: "16px", // Reduce padding
    fontSize: "14px", // Optional: Adjust font size if needed
  },
  tableContainer: {
    marginTop: "10px", // Reduce margin between table and other components
  },
  tableCellThickerBorder: {
    padding: "8px", // You can keep the existing padding
    fontSize: "14px",
    border: "2px solid black", // Add thicker border
  },
  tableBorder: {
    border: "2px solid black",
  },
  whiteSelect: {
    backgroundColor: "white !important",
    "& .MuiSelect-select": {
      backgroundColor: "white !important",
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "white !important",
    },
  },
  deptSelectRoot: {
    backgroundColor: "white !important",
    borderRadius: "4px",
    "&:hover $deptSelectNotchedOutline": {
      borderColor: "black !important",
    },
    "&$deptSelectFocused $deptSelectNotchedOutline": {
      borderColor: "black !important",
    },
  },
  deptSelectFocused: {},
  deptSelectNotchedOutline: {
    borderColor: "black !important",
  },
  deptSelectInput: {
    backgroundColor: "white !important",
    color: "black !important",
  },
}));

const RolesAndAccessDashboard = () => {
  const [open, setOpen] = useState(false);
  const [openTeamMemberColumn, setOpenTeamMemberColumn] = useState(false);
  const [selectedRoleType, setSelectedRoleType] = useState("");
  const [page, setPage] = useState(0); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page
  const [selectedDepartment, setSelectedDepartment] = useState(0); // Selected department
  const [isRefreshing, setIsRefreshing] = useState(false); // Track refresh state (for table only)
  const dispatch = useDispatch();
  const classes = useStyles();
  const [departments, setDepartments] = useState([]);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [inviteDrawer, setInviteDrawer] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(0);

  const [viewRolesAndAccessScreen, setViewRolesAndAccessScreen] =
    useState(false);
  const [editRolesAndAccessScreen, setEditRolesAndAccessScreen] =
    useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  const screenAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess.data.manageRoleAndAccess
  );

  const featuresAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl.featuresAccess.manageRoleAndAccess
    // (state) => state.pcmp.common.accessControl.featuresAccess
  );

  useEffect(() => {
    if (screenAccess?.screenAccess && !featuresAccess)
      dispatch(
        getFeaturesAccess(screenAccess?.screenId, "manageRoleAndAccess")
      );
    // We can pick up DS screen Id from access screensAccess.data.deliverySchedule.screenId
  }, [dispatch, screenAccess, featuresAccess]);

  const screenAccessTeamMembers = useSelector(
    (state) =>
      state.pcmp.common.accessControl.screensAccess.data.manageTeamMembers
  );

  const featuresAccessTeamMembers = useSelector(
    (state) => state.pcmp.common.accessControl.featuresAccess.manageTeamMembers
  );

  useEffect(() => {
    if (screenAccessTeamMembers?.screenAccess && !featuresAccessTeamMembers)
      dispatch(
        getFeaturesAccess(
          screenAccessTeamMembers?.screenId,
          "manageTeamMembers"
        )
      );
    // We can pick up DS screen Id from access screensAccess.data.deliverySchedule.screenId
  }, [dispatch, screenAccessTeamMembers, featuresAccessTeamMembers]);

  const departmentDetails = useSelector((state) =>
    state?.user?.fetchDepartments?.data
      ? state?.user?.fetchDepartments.data
      : []
  );

  const fetchDepartmentsList = useSelector((state) =>
    state?.user?.fetchUserfromDeptDetails?.departmentDetailsList
      ? state?.user?.fetchUserfromDeptDetails?.departmentDetailsList
      : []
  );

  //Handle change in department selection

  const RolesAndAccessList = useSelector((state) => {
    return (
      state?.pcmp?.common?.rolesAndAccess?.rolesAndAccessDetails
        ?.rolesAndAccessDashboard || []
    );
  });

  const rolesAndAccessDetailsLoading = useSelector((state) => {
    return (
      state?.pcmp?.common?.rolesAndAccess?.rolesAndAccessDetailsLoading || []
    );
  });

  const dashboardStatus = useSelector((state) => {
    return (
      state?.pcmp?.common?.rolesAndAccess?.rolesAndAccessDetails?.status || []
    );
  });

  const rolesAndAccessData = useSelector(
    (state) => state?.pcmp?.common?.rolesAndAccess?.rolesAndAccessDetails
  );

  const numberOfPages = rolesAndAccessData?.numberOfPages || 0;

  // useEffect(() => {

  //     dispatch(
  //       fetchRolesAndAccess({
  //         departmentID: selectedDepartmentId,
  //         pageNumber,
  //         pageSize,
  //       })
  //     ); // Fetch data when component mounts or refresh is not happening
  //   },
  //   [dispatch, isRefreshing, selectedDepartment]);

  // useEffect(() => {
  //   dispatch(
  //     fetchRolesAndAccess({
  //       departmentID: selectedDepartmentId,
  //       pageNumber, // Send the current page number
  //       pageSize,   // Send the selected page size
  //     })
  //   );
  // }, [dispatch, isRefreshing, selectedDepartmentId, pageNumber, pageSize]);

  useEffect(() => {
    dispatch({
      type: FETCH_ROLES_AND_ACCESS_LOADING,
      payload: true,
    });

    dispatch(
      fetchRolesAndAccess({
        departmentID: selectedDepartmentId,
        pageNumber,
        pageSize,
      })
    );
  }, [dispatch, isRefreshing, selectedDepartmentId, pageNumber, pageSize]);

  useEffect(() => {
    dispatch(
      fetchUserfromDepartment()
      //   {
      //   departmentID: selectedDepartmentId,
      // }
    );
  }, []);

  useEffect(() => {
    dispatch(fetchDepartmentDetails());
  }, []);

  const openViewScreen = (role, userCount) => {
    setSelectedRole({ ...role, userCount });
    setViewRolesAndAccessScreen(true);
  };
  const closeViewScreen = () => {
    setViewRolesAndAccessScreen(false);
  };

  const openEditScreen = (role, userCount) => {
    setSelectedRole({ ...role, userCount });
    setEditRolesAndAccessScreen(true);
  };
  const closeEditScreen = () => {
    setEditRolesAndAccessScreen(false);
  };

  const handleOpen = (role, userCount) => {
    setSelectedRoleType({ ...role, userCount });
    setOpenTeamMemberColumn(true);
  };

  const handleCloseColumn = () => {
    setOpenTeamMemberColumn(false);
  };

  const handleClose = () => {
    dispatch({
      type: UPDATE_COLLABORATOR_ROLE_CHANGES,
      value: {},
    });
    handleRefresh();
    setOpenSuccessDialog(false);
    if (openTeamMemberColumn) {
      handleCloseColumn();
    } else {
      closeEditScreen();
    }
  };

  const handleDepartmentChange = (event) => {
    const selectedDeptName = event.target.value; // Get selected department name
    setSelectedDepartment(selectedDeptName); // Update department name in state

    // Find the department ID by looking for the department name in the list
    const selectedDept = fetchDepartmentsList.find(
      (department) => department.departmentName === selectedDeptName
    );

    if (selectedDept) {
      setSelectedDepartmentId(selectedDept.departmentID); // Set department ID
    } else {
      setSelectedDepartmentId(0); // Default to 0 if no department found
    }

    setPage(0); // Reset to the first page whenever department changes
  };

  const handleClearFilter = () => {
    dispatch({
      type: FETCH_ROLES_AND_ACCESS_LOADING,
      payload: true,
    });
    dispatch(
      fetchRolesAndAccess({
        departmentID: 0,
        pageNumber,
        pageSize,
      })
    );
    setSelectedDepartmentId(0);
    setSelectedDepartment(0); // Reset to "all"
    setPage(0); // Reset page
  };

  // **Condition to Filter Data**:
  // Show data based on selected department
  const filteredData =
    selectedDepartment === "all"
      ? RolesAndAccessList // If "All" is selected, show all data
      : RolesAndAccessList.filter(
          (role) => role.departmentName === selectedDepartment
        ); // Show data only for selected department

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < numberOfPages) {
      setPageNumber(newPage + 1); // Update pageNumber to reflect server-side pagination
    }
  };
  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize); // Update page size
    setPageNumber(1); // Reset to the first page
  };

  // **New handleRefresh**: Trigger refresh only for the table data
  const handleRefresh = () => {
    setIsRefreshing(!isRefreshing); // Set refresh state to true
    // dispatch(fetchRolesAndAccess({})); // Fetch the updated data again
    // setIsRefreshing(false); // Reset refresh state after fetching
  };

  return (
    <div style={{ padding: "0px 24px" }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ marginTop: "20px" }}
      >
        <Grid item>
          <Typography style={{ fontSize: "1rem" }} variant="h6">
            Access and permission settings for roles
          </Typography>
        </Grid>
        {featuresAccess?.createNewRole && (
          <Grid item>
            <Button
              startIcon={<AddIcon />}
              className={classes.blueButton}
              onClick={() => setOpen(true)}
            >
              Create New Role
            </Button>
            <Drawer
              anchor="right"
              open={open}
              onClose={() => setOpen(false)}
              classes={{ paper: classes.drawerPaper }}
            >
              <CreateNewRole
                handleRefresh={handleRefresh}
                setOpen={setOpen}
                departmentAPI={fetchDepartmentsList}
              />
            </Drawer>
          </Grid>
        )}
      </Grid>

      <div style={{ marginTop: "25px" }}>
        {/* <label
          htmlFor="department"
          style={{
            fontSize: "15px",
            fontWeight: "600",
            marginBottom: "15px",
           
          }}
        >
          Department
        </label> */}

        <Typography style={{ fontWeight: "bold", marginBottom: 4 }}>
          Department:
        </Typography>
        {errorMessage && (
          <div style={{ color: "red", marginBottom: "10px", fontSize: "14px" }}>
            {errorMessage}
          </div>
        )}

        <Grid container alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <FormControl
              variant="outlined"
              size="small"
              className="filter-field-value"
              style={{
                minWidth: 180,
                backgroundColor: "white",
                borderRadius: "4px",
                height: 40,
              }}
            >
              <Select
                id="department"
                value={selectedDepartment || "all"}
                onChange={handleDepartmentChange}
                displayEmpty
                input={
                  <OutlinedInput
                    labelWidth={0}
                    classes={{
                      root: classes.deptSelectRoot,
                      focused: classes.deptSelectFocused,
                      notchedOutline: classes.deptSelectNotchedOutline,
                      input: classes.deptSelectInput,
                    }}
                  />
                }
                style={{ height: 40, fontSize: 16 }}
                inputProps={{ "aria-label": "Department" }}
              >
                <MenuItem value="all">All</MenuItem>
                {fetchDepartmentsList.length > 0 ? (
                  fetchDepartmentsList.map((department) => (
                    <MenuItem
                      key={department.departmentID}
                      value={department.departmentName}
                    >
                      {department.departmentName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="" disabled>
                    No departments available
                  </MenuItem>
                )}
              </Select>
            </FormControl>

            <Typography
              onClick={handleClearFilter}
              style={{
                marginLeft: "15px",
                fontSize: "14px",
                textDecoration: "underline",
                cursor: "pointer",
                color: "blue",
              }}
            >
              Clear all filter
            </Typography>

            {/* <Grid               
                          style={{
                            gap: "10px",
                            marginTop: "4rem",
                            marginLeft:"1rem",
                          }}> */}
            {/* <Button
                            variant="contained"
                            color="primary"
                            // className={classes.search}
                            style={{
                              borderRadius: "2rem",
                              textTransform: "none",
                              whiteSpace: "nowrap",
                              marginLeft:"1rem",
                            }}
                            // onClick={handleSearch} 
                            disabled
                          >
                            Save Filters
                          </Button> */}
            {/* </Grid> */}
          </Box>

          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              className="last-synced-text"
              style={{ color: "gray", marginRight: "8px", fontSize: "14px" }}
            >
              {`Last synced @ ${moment(new Date()).format(
                "HH:mm:ss; DD MMMM, YYYY"
              )}`}
            </Typography>
            {/* **Highlight**: This is where the refresh button triggers a table refresh */}
            <Typography
              variant="body2"
              color="primary"
              className="refresh-button"
              style={{
                textDecoration: "underline",
                fontStyle: "italic",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontSize: "14px",
              }}
              onClick={handleRefresh} // Trigger the refresh function
            >
              Refresh
              <Refresh
                className="refresh-button svg"
                color="primary"
                fontSize="small"
              />
            </Typography>
          </Box>
        </Grid>
        <Box
          display="flex"
          alignItems="center"
          style={{ marginRight: "16px", justifyContent: "end" }}
        >
          <React.Fragment className="per-page-box">
            <Typography
              style={{
                fontWeight: "bold",
                marginRight: "8px",
                whiteSpace: "nowrap",
              }}
            >
              PER PAGE
            </Typography>
            <FormControl variant="outlined" size="small">
              <Select
                value={pageSize}
                onChange={handleChangeRowsPerPage}
                displayEmpty
                className={classes.selectDropdown}
                inputProps={{ "aria-label": "Rows per page" }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={15}>15</MenuItem>
                <MenuItem value={20}>20</MenuItem>
              </Select>
            </FormControl>
          </React.Fragment>
        </Box>
      </div>

      {/* Table Section */}
      <TableContainer
        component={Paper}
        style={{ marginTop: "20px", border: "1px solid #dadada" }}
      >
        <div
          className="default-table-styles"
          style={{ display: "flex", gap: "40px", alignItems: "flex-start" }}
        >
          <Table>
            <TableHead>
              <TableRow
                className={classes.tableRow}
                //  style={{
                //   backgroundColor: "#f5f5f5",
                // }}
              >
                <TableCell
                  className={classes.tableCell}
                  align="left"
                  style={{ verticalAlign: "middle" }}
                >
                  Department - Role
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  align="left"
                  style={{ verticalAlign: "middle" }}
                >
                  Team Members
                </TableCell>
                <TableCell
                  className={classes.tableCell}
                  align="left"
                  style={{ verticalAlign: "middle" }}
                >
                  Role Type
                </TableCell>
                {localStorage?.roleName === "Admin" &&
                (localStorage?.departmentId === "null" ||
                  Number(localStorage?.getItem("departmentId")) === 1) &&
                (featuresAccess?.viewRole ||
                  featuresAccess?.addTeamMembers ||
                  featuresAccess?.editRole) ? (
                  <TableCell
                    className={classes.tableCell}
                    align="center"
                    style={{ verticalAlign: "middle" }}
                  >
                    Actions
                  </TableCell>
                ) : (
                  <TableCell></TableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {rolesAndAccessDetailsLoading === true ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : RolesAndAccessList.length > 0 ? (
                RolesAndAccessList.map((role, index) => {
                  // Find the matching department
                  const matchingDepartment = fetchDepartmentsList.find(
                    (dept) => dept.departmentID === role.departmentID
                  );

                  // Find the matching role in the department
                  const matchingRole = matchingDepartment?.rolesList.find(
                    (r) => r.collaborator_role_id === role.collaborator_role_id
                  );

                  // Extract userCount or set to "N/A" if no match
                  const userCount = matchingRole ? matchingRole.userCount : 0;

                  const displayUserCount =
                    userCount === 0
                      ? "0 team members"
                      : userCount === 1
                      ? "1 team member"
                      : `${userCount} team members`;

                  return (
                    <TableRow key={index} className={classes.tableRow}>
                      <TableCell
                        className={classes.tableCell}
                        align="left"
                        style={{ verticalAlign: "middle" }}
                      >
                        <span className={classes.boldText}>
                          {role.departmentName &&
                          role.departmentName.trim() !== ""
                            ? `${role.departmentName} - ${role.role_name}`
                            : role.role_name}
                        </span>
                        <div>{role.role_description}</div>
                      </TableCell>
                      {/* {featuresAccess?.viewTeamMembers ? ( */}
                      <TableCell
                        className={classes.tableCell}
                        align="left"
                        style={{
                          color: "#0000ff",
                          textDecoration: "underline",
                          cursor: "pointer",
                          verticalAlign: "middle",
                        }}
                        onClick={() => handleOpen(role, userCount)}
                      >
                        {displayUserCount}
                      </TableCell>
                      {/* ) : (
                      <TableCell></TableCell>
                    )} */}
                      <TableCell
                        align="left"
                        style={{ verticalAlign: "middle" }}
                      >
                        {role.roleType} role
                      </TableCell>
                      <TableCell
                        className={classes.tableCell}
                        align="center"
                        style={{ verticalAlign: "middle" }}
                      >
                        <Box
                          display="flex"
                          justifyContent="end"
                          alignItems="center"
                        >
                          {localStorage?.roleName === "Admin" &&
                            (localStorage?.departmentId === "null" ||
                              Number(localStorage?.getItem("departmentId")) ===
                                1) &&
                            //  || Number(localStorage?.departmentId) === role.departmentID)
                            featuresAccess?.addTeamMembers && (
                              <Button
                                variant="contained"
                                size="small"
                                className={`${classes.actionButtonStyle} actionButton`}
                                onClick={() => {
                                  setInviteDrawer(true);
                                  sessionStorage.clear();
                                }}
                                style={{ minWidth: 120, marginRight: 8 }}
                              >
                                + Add team member
                              </Button>
                            )}
                          {role.roleType === "Default"
                            ? localStorage?.roleName === "Admin" &&
                              (localStorage?.departmentId === "null" ||
                                Number(
                                  localStorage?.getItem("departmentId")
                                ) === 1) &&
                              // || Number(localStorage?.departmentId) ===  role?.departmentID)
                              featuresAccess?.viewRole && (
                                <IconButton
                                  className={classes.iconButtonStyle}
                                  style={{ marginLeft: "10px" }}
                                  onClick={() =>
                                    openViewScreen(role, userCount)
                                  }
                                >
                                  <VisibilityIcon />
                                </IconButton>
                              )
                            : localStorage?.roleName === "Admin" &&
                              (localStorage?.departmentId === "null" ||
                                Number(
                                  localStorage?.getItem("departmentId")
                                ) === 1) &&
                              // || Number(localStorage?.departmentId) === role.departmentID
                              featuresAccess?.editRole && (
                                <>
                                  <IconButton
                                    className={classes.iconButtonStyle}
                                    style={{ marginLeft: "10px" }}
                                    onClick={() =>
                                      openEditScreen(role, userCount)
                                    }
                                  >
                                    <EditIcon />
                                  </IconButton>
                                </>
                              )}
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : rolesAndAccessData.status === false ? (
                <TableRow
                  style={{
                    border: "2px solid #FF0000",
                    backgroundColor: "#FFF0F0",
                  }}
                >
                  <TableCell colSpan={7} align="center">
                    Something went wrong. Please try again later.
                  </TableCell>
                </TableRow>
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No records found for the selected department
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </TableContainer>

      {/* Pagination Section */}
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        marginTop={2}
      >
        <IconButton
          className={classes.paginationButton}
          onClick={() => handleChangePage(pageNumber - 2)}
          disabled={pageNumber === 1}
          size="small"
        >
          <ChevronLeft fontSize="small" />
        </IconButton>
        <Typography variant="body2" style={{ margin: "0 8px" }}>
          {pageNumber} out of {numberOfPages} Pages
        </Typography>
        <IconButton
          className={classes.paginationButton}
          onClick={() => handleChangePage(pageNumber)}
          disabled={pageNumber >= numberOfPages}
          size="small"
        >
          <ChevronRight fontSize="small" />
        </IconButton>
      </Box>

      {viewRolesAndAccessScreen === true && (
        <ViewRolesAndAccess
          openDialog={viewRolesAndAccessScreen}
          closeViewScreen={closeViewScreen}
          selectedRole={selectedRole}
        />
      )}

      {openSuccessDialog && (
        <Dialog open={openSuccessDialog} maxWidth="sm" fullWidth>
          <DialogContent className={classes.dialogContent}>
            <CheckCircleIcon className={classes.avatar} />

            <Typography variant="h6" style={{ marginTop: "10px" }}>
              Role details updated successfully
            </Typography>
            <Typography variant="body1" style={{ marginTop: "10px" }}>
              The role details have been updated successfully.
            </Typography>

            <DialogActions className={classes.dialogActions}>
              <Button
                variant="contained"
                color="primary"
                endIcon={<ChevronRight />}
                style={{
                  borderRadius: "20px",
                  textTransform: "none",
                }}
                onClick={handleClose}
              >
                Ok
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      )}

      {editRolesAndAccessScreen && (
        <EditRolesAndAccess
          openDialog={editRolesAndAccessScreen}
          closeEditScreen={closeEditScreen}
          selectedRole={selectedRole}
          departmentDetails={departmentDetails}
          handleRefresh={handleRefresh}
          featuresAccess={featuresAccess}
          openSuccessDialog={openSuccessDialog}
          setOpenSuccessDialog={setOpenSuccessDialog}
        />
      )}

      <Drawer
        anchor="right"
        open={inviteDrawer}
        onClose={() => setInviteDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
      >
        {/* <CreateNewRole setOpen={setOpen} departmentAPI={departmentAPI} /> */}
        <InviteTeamMember
          setInviteDrawer={setInviteDrawer}
          departmentDetails={departmentDetails}
          handleRefresh={handleRefresh}
        />

        {/* <ViewDetails handleRefresh={handleRefresh} /> */}
      </Drawer>

      {openTeamMemberColumn && selectedRoleType.roleType === "Default" ? (
        <ViewTeamMembersColumn
          openDialog={openTeamMemberColumn}
          handleCloseColumn={handleCloseColumn}
          handleRefresh={handleRefresh}
          selectedRole={selectedRoleType}
          featuresAccessTeamMembers={featuresAccessTeamMembers}
        />
      ) : (
        <EditTeamMembersColumn
          openDialog={openTeamMemberColumn}
          handleCloseColumn={handleCloseColumn}
          departmentDetails={departmentDetails}
          handleRefresh={handleRefresh}
          featuresAccess={featuresAccess}
          selectedRole={selectedRoleType}
          fetchDepartmentsList={fetchDepartmentsList}
          closeEditScreen={closeEditScreen}
          featuresAccessTeamMembers={featuresAccessTeamMembers}
          openSuccessDialog={openSuccessDialog}
          setOpenSuccessDialog={setOpenSuccessDialog}
        />
      )}
    </div>
  );
};

export default RolesAndAccessDashboard;
